import { MIME_TYPES } from '@mantine/dropzone';

export type Option = {
    label: string;
    value: any;
    title?: string;
};

export enum TwoFactorEnums {
    Setup = 'setup',
    Verify = 'verify'
}

export enum Environments {
    dev = 'Dev',
    uat = 'Uat',
    demo = 'Demo'
}

export enum EntityAttributes {
    executingBroker = 'Executing Broker',
    customer = 'Customer',
    liquidityProvider = 'Liquidity Provider',
    fundManager = 'Fund Manager',
    custodian = 'Custodian',
    bank = 'Bank',
    agent = 'Agent',
    margin = 'Margin',
    deliverable = 'DELIVERABLE',
    allocationManager = 'Allocation Manager',
    allocationInvestor = 'Allocation Investor',
    whitelabel = 'WhiteLabel',
    gceEntity = 'GCE_Entity',
    transferReceiver = 'Transfer Receiver',
    referredClient = 'Referred Client',
    reseller = 'Reseller'
}

export enum WhitelistRequestType {
    WHITELIST_BANK_INFO = 'BANK ACCOUNT',
    WHITELIST_WALLET = 'WALLET ADDRESS',
    REMOVE_BANK_INFO = 'REMOVE BANK ACCOUNT',
    REMOVE_WALLET = 'REMOVE WALLET',
    WITHDRAWAL = 'WITHDRAWAL',
    DEPOSIT = 'DEPOSIT',
    UPDATE_WALLET = 'UPDATE WALLET',
    UPDATE_BANK_INFO = 'UPDATE BANK ACCOUNT',
    INTERNAL_TRANSFER = 'INTERNAL TRANSFER'
}

export enum DepositWithdrawalRequestType {
    WITHDRAWAL = 'Withdrawal',
    DEPOSIT = 'Deposit',
    INTERNAL_TRANSFER = 'Internal Transfer'
}

export enum DepositType {
    FIAT = 'FIAT',
    CRYPTO = 'CRYPTO'
}

export enum WithdrawalType {
    FIAT = 'FIAT',
    CRYPTO = 'CRYPTO'
}

export enum InternalTransferType {
    FIAT = 'FIAT',
    CRYPTO = 'CRYPTO'
}

export enum FileExtensionsBasedOnMimeType {
    'video/mp4' = '.mp4',
    'video/avi' = '.avi',
    'video/x-msvideo' = '.avi',
    'video/msvideo' = '.avi',
    'application/x-troff-msvideo' = '.avi',
    'video/mpeg' = '.mpeg',
    'video/webm' = '.webm'
}

export const notSupportedVideosTypes = [
    'video/avi',
    'video/x-msvideo',
    'video/msvideo',
    'application/x-troff-msvideo',
    'video/mpeg'
];

export enum WalletTypes {
    Regulated = 'Regulated Custodian Wallet',
    DeFi = 'Private DeFi Wallet',
    Hardware = 'Private Hardware Wallet',
    Service = 'Wallet as a Service'
}

export const walletTypeOptions: Option[] = [
    {
        label: WalletTypes.Regulated,
        value: WalletTypes.Regulated,
        title: 'Regulated Custodian Wallets'
    },
    {
        label: WalletTypes.DeFi,
        value: WalletTypes.DeFi,
        title: 'For example MetaMask, WalletConnect'
    },
    {
        label: WalletTypes.Hardware,
        value: WalletTypes.Hardware,
        title: 'For example Ledger, KeepKey, Coldcard'
    },
    {
        label: WalletTypes.Service,
        value: WalletTypes.Service,
        title: 'For example Fireblocks, BlockFi, Alchemy'
    }
];

export const maxFiles = 1;
export const maxFileSize = 10 * 1024 * 1024;
export const acceptedFileTypes = [
    MIME_TYPES.png,
    MIME_TYPES.jpeg,
    MIME_TYPES.pdf,
    MIME_TYPES.mp4,
    'video/avi',
    'video/x-msvideo',
    'video/msvideo',
    'application/x-troff-msvideo',
    'video/mpeg',
    'video/webm'
];

export const DropzoneErrorMessage: {
    [key: string]: string;
} = {
    'file-too-large': 'File size should be less than 10MB',
    'file-invalid-type': 'Unsupported File Format. Only format allowed are JPEG, PNG, PDF, MP4, WEBM, AVI, MPG',
    'too-many-files': 'Only one file is allowed'
};
